import Select from "react-select";
import { useTranslation } from "react-i18next";
import type { ThemeClasses } from "../types";
import { getCustomSelectStyles } from "../../../../Layouts/admin/shared";
import { useStatusesStore } from "../../../../store/admin/statusesStore";
import { getStatusOptionsForEntity } from "../../../../utils/getStatusEntity";

interface UserFiltersProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  selectedStatus: string;
  searchQuery: string;
  onStatusChange: (value: string) => void;
  onSearchChange: (value: string) => void;
}

export function UserFilters({
  themeClasses,
  isDarkMode,
  selectedStatus,
  searchQuery,
  onStatusChange,
  onSearchChange,
}: UserFiltersProps) {
  const { t } = useTranslation("adminSections");
  const statuses = useStatusesStore((state) => state.statuses);
  const statusOptionsSelect = getStatusOptionsForEntity(statuses, "users", t);

  // Agregar opción "Todos" al inicio
  const statusOptions = [
    { value: "all", label: t("statuses.all", "Todos los estados") },
    ...statusOptionsSelect,
  ];

  return (
    <>
      {/* Status Filter */}
      <div className="w-full md:min-w-[200px]">
        <Select
          options={statusOptions}
          styles={getCustomSelectStyles(isDarkMode)}
          value={statusOptions.find((opt) => opt.value === selectedStatus)}
          onChange={(option: any) => onStatusChange(option?.value || "all")}
          isSearchable={false}
          isClearable
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </div>

      {/* Search */}
      <div className="relative w-full md:min-w-[200px]">
        <i
          className={`ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 ${themeClasses.textSecondary} text-sm`}
        ></i>
        <input
          type="text"
          placeholder={t("users.searchPlaceholder")}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={`w-full pl-10 py-2 ${
            isDarkMode ? "bg-dark-card" : "bg-gray-50"
          } border ${themeClasses.cardBorder} rounded-lg ${
            themeClasses.text
          } placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm`}
        />
      </div>
    </>
  );
}
